import { post, get } from "services/network/endpoint"
import { dispatchHandler } from "services/utils/action"
import * as ActionTypes from "services/state/action-types"
import { BFF } from "services/network/routes"

export const createTechnicalSupportProtocol = (
  data,
  callback,
  callbackFail
) => {
  return (dispatch) => {
    const config = {
      pathValues: {},
      client: BFF,
      data
    }
    const request = post("createTechnicalSupportProtocol", config)

    return dispatch({
      type: ActionTypes.CREATE_PROTOCOL_TECHNICAL_SUPPORT,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export const checkVerifyMassive = (data, callback, callbackFail) => {
  return (dispatch) => {
    const config = {
      pathValues: {},
      client: BFF,
      data
    }
    const request = post("checkVerifyMassive", config)

    return dispatch({
      type: ActionTypes.CHECK_VERIFY_MASSIVE,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export const getSupportOrder = (data, callback, callbackFail) => {
  return (dispatch) => {
    const config = {
      pathValues: data,
      client: BFF,
      data
    }
    const request = get("getSupportOrder", config)

    return dispatch({
      type: ActionTypes.GET_SUPPORT_ORDER,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export const supportListModem = (data, callback, callbackFail) => {
  return (dispatch) => {
    const config = {
      pathValues: {},
      client: BFF,
      data
    }
    const request = post("supportListModem", config)

    return dispatch({
      type: ActionTypes.SUPPORT_LIST_MODEM,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export const supportResetModem = (data, callback, callbackFail) => {
  return (dispatch) => {
    const config = {
      pathValues: {},
      client: BFF,
      data
    }
    const request = post("supportResetModem", config)

    return dispatch({
      type: ActionTypes.SUPPORT_RESET_MODEM,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function createInteraction(data, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: {},
      client: BFF,
      data
    }
    const request = post("interaction", config)

    return dispatch({
      type: ActionTypes.GET_INTERACTION,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function openTicket(data, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: {},
      client: BFF,
      data
    }
    const request = post("openTicket", config)

    return dispatch({
      type: ActionTypes.OPEN_TICKET,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function getSupportTimeSlots(data, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: data,
      client: BFF,
      data
    }
    const request = get("getSupportTimeSlots", config)

    return dispatch({
      type: ActionTypes.SUPPORT_TIME_SLOTS,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}

export function createSupportScheduling(data, callback, callbackFail) {
  return (dispatch) => {
    const config = {
      pathValues: data,
      client: BFF,
      data
    }
    const request = post("createSupportScheduling", config)
    return dispatch({
      type: ActionTypes.CREATE_SUPPORT_SCHEDULING,
      payload: request
    }).then(dispatchHandler(callback, callbackFail))
  }
}



// WEBPACK FOOTER //
// ./src/services/state/technicalSupport/action.js